module.exports = __webpack_public_path__ + "static/media/joomla.2617f2f8.png";